import { plainToClass } from "class-transformer";
import { InitializeFilterDropdown } from "../../../../shared/scripts/filtering/filtering.utilities";
import { Unique } from "../../../../shared/scripts/array-functions";

export class CTMSUserDetailsPage {
    userId: number;
    token: string;
    userDetails: any;
    mySites: any[];
    checkedSiteIds: Set<number> = new Set();
    allSiteSettings: any[] = [];
    assignedSites: number[] = [];
    editUserSitesTable: any;
    mySitesTable: any;

    constructor(userId: number, mySitesJson: any) {
        $(() => {
            this.token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');
            this.userId = userId;
            this.mySites = mySitesJson || [];
            this.initializeModal();
            this.setupEditUserDialog();
            this.initMySitesTable();
            this.setupEditUserSiteButton();
            this.setupSaveUserSiteAssignment();
            $('#editUserSiteDialog').on('shown.bs.modal', () => {
                if (this.editUserSitesTable) {
                    this.editUserSitesTable.columns.adjust();
                }
            });
        });
    }

    initializeModal() {
        $('#editUserDialog').on('show.bs.modal', () => {
            const name = $('#userDetailsName').text().trim();
            const email = $('#userDetailsEmail').text().trim();
            const phone = $('#userDetailsPhone').text().trim();
            $('#editUserDialog input[name="Name"]').val(name);
            $('#editUserDialog input[name="Email"]').val(email);
            $('#editUserDialog input[name="PhoneNumber"]').val(phone);
        });
    }

    setupEditUserDialog() {
        const self = this;
        $('#editUserDialog').modal({
            backdrop: 'static',
            show: false
        });
        $('#editUserDialog .ctms-button-save').off('click').on('click', function (e) {
            const f = document.getElementById('userDialogForm') as HTMLFormElement;
            if (f.checkValidity()) {
                $('#userDialogForm').removeClass('ctms-invalid-form');
                const formData = $('#editUserDialog .ctms-field-submit').serialize();
                $.ajax({
                    url: `/secure/ctms/settings/user-details?handler=UpdateUserDetails&id=${self.userId}`,
                    headers: { "RequestVerificationToken": self.token },
                    type: 'POST',
                    data: formData,
                    success: function (resp) {
                        if (resp && resp.Name) {
                            $(".ctms-breadcrumb-detail").text(' ' + resp.Name);
                            $("#userDetailsName").text(resp.Name);
                            $("#userDetailsEmail").text(resp.Email);
                            $("#userDetailsPhone").text(resp.PhoneNumber);
                            $('#editUserDialog input[name="Name"]').val(resp.Name);
                            $('#editUserDialog input[name="Email"]').val(resp.Email);
                            $('#editUserDialog input[name="PhoneNumber"]').val(resp.PhoneNumber);
                        }
                        $('#editUserDialog').modal('hide');
                    },
                    error: function () {
                        alert('Error updating user details.');
                        f.reset();
                        $('#editUserDialog').modal('hide');
                    }
                });
            } else {
                $('#userDialogForm').addClass('ctms-invalid-form');
            }
            e.preventDefault();
            e.stopPropagation();
        });
    }

    initMySitesTable() {
        this.mySitesTable = $('#my-sites-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '40vh',
            scrollCollapse: true,
            orderCellsTop: true,
            columns: [
                { data: 'SiteNumber', title: 'Site Number', width: '120px' },
                { data: 'SiteName', title: 'Site Name' }
            ],
            order: [[0, 'asc']],
            data: this.mySites
        });
    }

    setupEditUserSiteButton() {
        const self = this;
        $('#editUserSiteButton').off('click').on('click', function () {
            $.ajax({
                url: `/secure/ctms/settings/user-details?handler=SiteSettingsDto&id=${self.userId}`,
                method: 'GET',
                headers: { "RequestVerificationToken": self.token },
                success: function (resp) {
                    if (resp && resp.success && resp.userSite) {
                        self.allSiteSettings = mapKeysToPascalCase(resp.userSite.allSites) || [];
                        self.assignedSites = resp.userSite.assignedSites || [];
                        self.checkedSiteIds = new Set(self.assignedSites);
                        self.showEditUserSitesModal();
                        if (self.editUserSitesTable) self.editUserSitesTable.draw();
                    } else {
                        alert('Could not load site settings.');
                    }
                },
                error: function () {
                    alert('Error loading site settings.');
                }
            });
        });
    }

    showEditUserSitesModal() {
        const self = this;
        if (self.editUserSitesTable) {
            self.editUserSitesTable.destroy();
            $('#edit-user-sites-table').empty();
        }
        self.editUserSitesTable = $('#edit-user-sites-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '40vh',
            scrollCollapse: true,
            orderCellsTop: true,
            columns: [
                {
                    data: null,
                    title: '<input type="checkbox" />',
                    className: "ctms-table-col-check",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<input type="checkbox" class="assign-site-checkbox" data-id="${row.Id}" />`;
                    }
                },
                { data: 'SiteNumber', title: 'Site Number', width: '120px' },
                { data: 'SiteName', title: 'Site Name' }
            ],
            order: [[1, 'asc']],
            data: self.allSiteSettings
        });

        $('#filter-userSite-search-input').on('input', function () {
            $('#edit-user-sites-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('#filter-userSite-search-clear').on('click', function () {
            $('#filter-userSite-search-input').val('');
            $('#edit-user-sites-table').DataTable().search('').draw();
        });
        // Listen for checkbox changes
        $('#edit-user-sites-table tbody').on('change', '.assign-site-checkbox', function () {
            const id = Number($(this).attr('data-id'));
            if ($(this).prop('checked')) {
                self.checkedSiteIds.add(id);
            } else {
                self.checkedSiteIds.delete(id);
            }
        });
        // On table draw, restore checked state
        self.editUserSitesTable.on('draw', function () {
            self.editUserSitesTable.rows().every(function () {
                const $row = $(this.node());
                const rowData = this.data();
                const $checkbox = $row.find('.assign-site-checkbox');
                if ($checkbox.length && self.checkedSiteIds.has(rowData.Id)) {
                    $checkbox.prop('checked', true);
                } else {
                    $checkbox.prop('checked', false);
                }
            });
        });
        $('#editUserSiteDialog').modal({
            backdrop: 'static',
            show: true
        });
    }

    setupSaveUserSiteAssignment() {
        const self = this;
        $('#saveUserSiteAssignment').off('click').on('click', function () {
            const assignedSites = Array.from(self.checkedSiteIds);
            const formData = new FormData();
            formData.append('Id', String(self.userId));
            formData.append('AssignedSites', JSON.stringify(assignedSites));
            $.ajax({
                url: `/secure/ctms/settings/user-details?handler=SaveUserSite`,
                method: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: formData,
                headers: { "RequestVerificationToken": self.token },
                success: function (resp) {
                    if (resp && resp.success && resp.userSites) {
                        self.updateMySitesTable(resp.userSites);
                        $('#editUserSiteDialog').modal('hide');
                    } else {
                        alert('Could not save site assignment.');
                    }
                },
                error: function () {
                    alert('Error saving site assignment.');
                }
            });
        });
    }

    updateMySitesTable(newSites: any[]) {
        this.mySites = mapKeysToPascalCase(newSites) || [];
        if (this.mySitesTable) {
            this.mySitesTable.clear();
            this.mySitesTable.rows.add(this.mySites).draw();
        }
    }
}

function mapKeysToPascalCase(obj: any): any {
    if (Array.isArray(obj)) {
        return obj.map(mapKeysToPascalCase);
    }
    if (obj !== null && typeof obj === 'object') {
        const newObj: any = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
                newObj[pascalKey] = mapKeysToPascalCase(obj[key]);
            }
        }
        return newObj;
    }
    return obj;
}